import { render, staticRenderFns } from "./HubIcon.vue?vue&type=template&id=1482122f&scoped=true&"
import script from "./HubIcon.vue?vue&type=script&lang=ts&"
export * from "./HubIcon.vue?vue&type=script&lang=ts&"
import style0 from "./HubIcon.vue?vue&type=style&index=0&id=1482122f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1482122f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
